import { EventEmitter, Injectable } from '@angular/core';
import { ApiManagerService } from './api-manager.api.service';
import { AbstractApiService } from './abstract.api.service';
import { TrainingBlock, TrainingBlockStatus } from 'src/app/classes/TrainingBlock.class';
import { GET_QUIZES } from '../../lib/contsants';

@Injectable({
  providedIn: 'root',
})
export class TrainingsApiService extends AbstractApiService {
  mystatusChanged: EventEmitter<any> = new EventEmitter();

  constructor(protected apiManager: ApiManagerService) {
    super(null);
  }

  protected getApi(endpoint: string): string {
    return this.apiManager.apiBuilder(endpoint);
  }

  async getAllBlocks() {
    return this.getBlocksByStatus(null);
  }

  async getReleasedBlocks() {
    return this.getBlocksByStatus(TrainingBlockStatus.Released);
  }

  async getDeletedBlocks() {
    return this.getBlocksByStatus(TrainingBlockStatus.Deleted);
  }

  async saveBlock(blockData: TrainingBlock) {
    const options: RequestInit = {
      body: JSON.stringify(blockData),
    };

    const data =
      blockData.id && blockData !== null
        ? await this.saveData(`${GET_QUIZES}/${blockData.id}`, options)
        : await this.post(this.getApi(`${GET_QUIZES}`), options);

    return data;
  }

  async saveChangedBlockOrders(block: TrainingBlock) {
    const options: RequestInit = {
      body: JSON.stringify(block),
    };

    const endpoint = `${GET_QUIZES}/${block.id}`;
    return this.saveData(endpoint, options);
  }

  async deleteBlock(blockData: TrainingBlock) {
    blockData.status = TrainingBlockStatus.Deleted;
    blockData.ordering = null;
    const options: RequestInit = {
      body: JSON.stringify(blockData),
    };

    const endpoint = `${GET_QUIZES}/${blockData.id}`;

    return this.saveData(endpoint, options);
  }

  async blockUndoDelete(blockData: TrainingBlock, order: number) {
    blockData.status = TrainingBlockStatus.Released;
    blockData.ordering = order;
    const options: RequestInit = {
      body: JSON.stringify(blockData),
    };

    const endpoint = `${GET_QUIZES}/${blockData.id}`;

    return this.saveData(endpoint, options);
  }

  private async getBlocksByStatus(status: TrainingBlockStatus | null) {
    const response = await this.get(this.getApi(GET_QUIZES));
    return response.data.filter(block => status === null || block.status === status);
  }

  private async saveData(endpoint: string, options: RequestInit) {
    if (endpoint && options) {
      return this.patch(this.getApi(endpoint), options);
    }

    return null;
  }
}
